import CardIcon from 'assets/images/cardNumber/payment.svg'
import CopyIcon from 'assets/images/cardNumber/content_copy.svg'
import StartIcon from 'assets/images/cardNumber/star_border.svg'
import DeleteIcon from 'assets/images/cardNumber/delete.svg'
import { toast } from 'react-toastify'
import useSetDefault from './hooks/useSetDefault'
import useSetDelete from './hooks/useSetDelete'
import { useNavigate } from 'react-router-dom'
interface IOpenBank {
    open: boolean
    item: IBankCardsResult | undefined
}
interface IItemProps {
    item: IBankCardsResult
    setIsOpen: React.Dispatch<React.SetStateAction<IOpenBank>>
    refetch: () => void
}
export default function BottomSheetItems({
    item,
    setIsOpen,
    refetch,
}: IItemProps) {
    const { defaultMutate } = useSetDefault(setIsOpen, refetch)
    const { deleteMutate } = useSetDelete(setIsOpen, refetch)
    const navigate = useNavigate()
    return (
        <div>
            {item.card_number ? (
                <p className=" my-2 text-center text-sm">
                    {item.card_number.match(/.{1,4}/g)?.join('\xa0\xa0')}
                </p>
            ) : (
                <p className=" my-2 text-center text-sm">
                    {item.iban.match(/.{1,4}/g)?.join('\xa0\xa0')}
                </p>
            )}
            <hr className=" my-3" />
            <div className=" px-4">
                <div className=" flex my-3">
                    <img src={CardIcon} alt="card" />
                    <p
                        className=" mx-3"
                        onClick={() => {
                            navigate('/manage-bank-cards/history', {
                                state: { id: item.id, item: item },
                            })
                        }}
                    >
                        سوابق واریزی
                    </p>
                </div>
                <div className=" flex my-3">
                    <img src={CopyIcon} alt="card" />
                    <p
                        className=" mx-3"
                        onClick={(e) => {
                            navigator.clipboard.writeText(
                                item.card_number ? item.card_number : item.iban
                            )
                            toast.success('کپی شد')
                            setIsOpen({ open: false, item: undefined })
                        }}
                    >
                        {' '}
                        {item.card_number ? 'کپی شماره کارت' : 'کپی شماره شبا'}
                    </p>
                </div>
                <div className=" flex my-3">
                    <img src={StartIcon} alt="card" />
                    <p
                        className=" mx-3"
                        onClick={() => {
                            defaultMutate(item.id)
                        }}
                    >
                        {' '}
                        انتخاب به عنوان کارت پیش‌فرض
                    </p>
                </div>
                <div className=" flex my-3">
                    <img src={DeleteIcon} alt="card" />
                    <p
                        className=" mx-3"
                        onClick={() => {
                            deleteMutate(item.id)
                        }}
                    >
                        حذف کارت
                    </p>
                </div>
            </div>
        </div>
    )
}
